import { types } from '../actions/stopsActions';
import initialState from './initialState';

export default function stopsReducer(state = initialState.stopsReducer, action) {
  switch (action.type) {
    case types.LOADING_STOPS_FOR_FIELD:
      return { ...state, ...{ stops: [], isLoading: true } };
    case types.LOAD_STOPS_FOR_FIELD_FAILURE:
      return { ...state, ...{ stops: [], isLoading: false } };
    case types.LOAD_STOPS_FOR_FIELD_SUCCESS:
      return { ...state, ...{ stops: action.items.filter((stop) => !stop.isDeleted), isLoading: false } };
    default:
      return state;
  }
}
